export default "__VITE_ASSET__DMcGs87o__"